import React from "react";
import { useTranslation } from "react-i18next";
import { INewsFlat } from "../../domain/models/News";
import { formatDateLong } from "../../utils/DateUtils";
import languageServiceFactory from "../../services/LanguageServiceImpl";

interface NewsMetaInfoProps {
    news: INewsFlat;
    author?: string;
    views?: number;
}

const languageService = languageServiceFactory();

const NewsMetaInfo: React.FC<NewsMetaInfoProps> = ({
    news,
    author,
    views
}) => {
    const { t } = useTranslation();
    const locale = languageService.getLocale();
    const defaultAuthor = t("news.meta.defaultAuthor");
    const defaultViews = 0;

    return (
        <div className="flex flex-col md:flex-row items-start md:items-center gap-[8px] md:gap-[32px] whitespace-nowrap text-text-300 font-geologica font-normal text-[16px] leading-[1.3] mb-[24px]">
            {news.createdAt && (
            <span>
                {formatDateLong(news.createdAt)}
            </span>
            )}
            <span>{t("news.meta.author")}: {author || defaultAuthor}</span>
            <span>{t("news.meta.views")}: {(views || defaultViews).toLocaleString(locale)}</span>
        </div>
    );
};

export default NewsMetaInfo;